import { useEffect, useState } from "react";
import {
  Card,
  Box,
  Typography,
  Button,
  Chip,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import "./details.css";
import EditFirmDetails from "./edit-firm-details/edit-firm-details";
import EditContactDetails from "./edit-contact-details/edit-contact-details";
// import EditSFSContactDetails from "./edit-sfs-contact-details/edit-sfs-contact-details";
import DeactivateInspectionFirm from "./deactivate-inspection-firm/deactivate-inspection-firm";
import ReActivateInspectionFirm from "./re-activate-inspection-firm/re-activate-inspection-firm";
import {
  getFormattedEstablishedDate,
  phoneFormatInput,
} from "../../../../../utils/Formatter";
import ContactLayout from "../../../../../components/contact-layout/contact-layout";

type props = {
  data: any;
};

export default function Details({ data }: props) {
  const [isActive, setIsActive] = useState(data?.isActive || false);
  const [primaryPhone, setPrimaryPhone] = useState<any>();
  const [altPhones, setAltPhones] = useState<any>([]);
  const [primaryAccountManager, setPrimaryAccountManager] = useState<any>();
  const [altAccountManager, setAltAccountManager] = useState<any>([]);
  const [primaryAccountingContact, setPrimaryAccountingContact] =
    useState<any>();
  const [altAccountingContact, setAltAccountingContact] = useState<any>([]);
  // const [primaryRelationshipManager, setPrimaryRelationshipManager] =
  //   useState<any>();
  // const [altRelationshipManager, setAltRelationshipManager] = useState<any>([]);
  const [showEditInspectionFirm, setShowEditInspectionFirm] = useState(false);
  const [showEditContact, setShowEditContact] = useState(false);
  // const [showEditSFSContact, setShowEditSFSContact] = useState(false);
  const [showDeactivateInspectionFirm, setShowDeactivateClient] =
    useState(false);
  const [showReActivateInspectionFirm, setShowReActivateClient] =
    useState(false);

  useEffect(() => {
    if (data) {
      setIsActive(data?.isActive);
      const filterPrimaryPhones = data?.phones.filter(
        (phone: any) => phone.isPrimary === true
      );
      const filterAltPhones = data?.phones.filter(
        (phone: any) => phone.isPrimary === false
      );
      setPrimaryPhone(filterPrimaryPhones[0]);
      setAltPhones(filterAltPhones);

      const filterPrimaryAccountManager = data?.accountManagers.filter(
        (accountManager: any) => accountManager.isPrimary === true
      );
      const filterAltAccountManager = data?.accountManagers.filter(
        (accountManager: any) => accountManager.isPrimary === false
      );
      setPrimaryAccountManager(filterPrimaryAccountManager[0]);
      setAltAccountManager(filterAltAccountManager);

      const filterPrimaryAccountingContact = data?.accountingContacts.filter(
        (accountingContact: any) => accountingContact.isPrimary === true
      );
      const filterAltAccountingContact = data?.accountingContacts.filter(
        (accountingContact: any) => accountingContact.isPrimary === false
      );
      setPrimaryAccountingContact(filterPrimaryAccountingContact[0]);
      setAltAccountingContact(filterAltAccountingContact);

      // const filterPrimaryRelationshipManager =
      //   data?.relationShipManagers.filter(
      //     (relationShipManager: any) => relationShipManager.isPrimary === true
      //   );
      // const filterAltRelationshipManager = data?.relationShipManagers.filter(
      //   (relationShipManager: any) => relationShipManager.isPrimary === false
      // );
      // setPrimaryRelationshipManager(filterPrimaryRelationshipManager[0]);
      // setAltRelationshipManager(filterAltRelationshipManager);
    }
  }, [data]);

  const handleEditClient = () => {
    setShowEditInspectionFirm(true);
  };

  const handleEditContact = () => {
    setShowEditContact(true);
  };

  // const handleEditSFSContact = () => {
  //   setShowEditSFSContact(true);
  // };

  const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    // setIsActive(isChecked);
    if (isChecked === false) {
      setShowDeactivateClient(true);
    } else {
      setShowReActivateClient(true);
    }
  };

  const CompanyEstablishedInfo = () => {
    const formattedEstablishedOn = () => {
      const { month, year } = data?.establishedOn || {};
      return getFormattedEstablishedDate(month, year);
    };

    return formattedEstablishedOn() ? (
      <>
        <Typography>
          {formattedEstablishedOn()?.[0]}{" "}
          <span className="establised-date">
            ({formattedEstablishedOn()?.[1]})
          </span>
        </Typography>
      </>
    ) : null;
  };

  useEffect(() => {
    setIsActive(data?.isActive || false);
  }, [data]);

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Firm Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditClient}
          >
            Edit
          </Button>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Status</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch checked={isActive} onChange={handleStatusChange} />
              }
              label={isActive ? "Active" : "Inactive"}
            />
          </FormGroup>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Max Capacity</Typography>
          <Typography>{data?.maxCapacity}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Inspection Firm Name</Typography>
          <Typography>{data?.displayName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Inspection Firm Alias <br /> (Optional){" "}
          </Typography>
          <Typography>{data?.aliasName}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Grade</Typography>
          <Typography>
            {data?.gradeLetter &&
              data?.grade &&
              `${data?.gradeLetter} (${data?.grade} GPA)`}
          </Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Company ID</Typography>
          <Typography>{data?.companyId}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Website</Typography>
          <Box display={"flex"} alignItems={"center"}>
            <Typography sx={{ color: "#E35F00" }}>{data?.website}</Typography>
            <Button>
              <OpenInNewOutlinedIcon />
            </Button>
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            When was the Business Established?
          </Typography>
          <CompanyEstablishedInfo />
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Company Owned By</Typography>
          <Box>
            {data?.ownerships?.length > 0 &&
              data?.ownerships?.map((ownership: any) => (
                <Typography>{ownership?.displayName}</Typography>
              ))}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Memberships</Typography>
          <Box>
            {data?.memberships?.length > 0 &&
              data?.memberships?.map((membership: any) => (
                <Typography>{membership?.displayName}</Typography>
              ))}
            <Typography>{data?.otherMemberships}</Typography>
          </Box>
        </Box>
      </Card>

      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Contact Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditContact}
          >
            Edit
          </Button>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Phone</Typography>
          <Box>
            {primaryPhone ? (
              <Box display={"flex"} alignItems="center">
                <Typography>{phoneFormatInput(primaryPhone?.phone)}</Typography>
                <Chip
                  sx={{ height: 24, ml: 1 }}
                  label="primary"
                  color="primary"
                  variant="outlined"
                />
              </Box>
            ) : (
              <Box>-</Box>
            )}
            {altPhones?.map((altPhone: any, index: number) => (
              <Typography key={index}>
                {phoneFormatInput(altPhone?.phone)}
              </Typography>
            ))}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Mailing Address</Typography>
          <Box>
            <Typography>{data?.mailingAddress?.street}</Typography>
            <Typography>{data?.mailingAddress?.address2}</Typography>
            <Typography>
              {data?.mailingAddress?.city}, {data?.mailingAddress?.state}{" "}
              {data?.mailingAddress?.zip}
            </Typography>
            <Typography>{data?.mailingAddress?.country}</Typography>
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Billing Address</Typography>
          <Box>
            <Typography>{data?.billingAddress?.street}</Typography>
            <Typography>{data?.billingAddress?.address2}</Typography>
            <Typography>
              {data?.billingAddress?.city}, {data?.billingAddress?.state}{" "}
              {data?.billingAddress?.zip}
            </Typography>
            <Typography>{data?.billingAddress?.country}</Typography>
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Account Manager/Admin</Typography>
          <Box>
            {primaryAccountManager ? (
              <ContactLayout data={primaryAccountManager} isPrimary={true} />
            ) : (
              <> - </>
            )}
            {altAccountManager.map((accountManager: any) => (
              <ContactLayout
                key={accountManager.userId}
                data={accountManager}
                isPrimary={false}
              />
            ))}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Accounting Contact</Typography>
          <Box>
            {primaryAccountingContact ? (
              <ContactLayout data={primaryAccountingContact} isPrimary={true} />
            ) : (
              <> - </>
            )}
            {altAccountingContact.map((accountingContact: any) => (
              <ContactLayout
                key={accountingContact.userId}
                data={accountingContact}
                isPrimary={false}
              />
            ))}
          </Box>
        </Box>
      </Card>

      {/* <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">SFS Contact Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditSFSContact}
          >
            Edit
          </Button>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">Relationship Manager</Typography>
          <Box>
            {primaryRelationshipManager ? (
              <ContactLayout
                data={primaryRelationshipManager}
                isPrimary={true}
              />
            ) : (
              <> - </>
            )}
            {altRelationshipManager.map((relationshipManager: any) => (
              <ContactLayout
                key={relationshipManager.userId}
                data={relationshipManager}
                isPrimary={false}
              />
            ))}
          </Box>
        </Box>
      </Card> */}

      {showEditInspectionFirm && (
        <EditFirmDetails
          showDialog={showEditInspectionFirm}
          closeDialog={() => setShowEditInspectionFirm(false)}
          data={data}
        />
      )}

      {showEditContact && (
        <EditContactDetails
          showDialog={showEditContact}
          closeDialog={() => setShowEditContact(false)}
          data={data}
        />
      )}

      {/* {showEditSFSContact && (
        <EditSFSContactDetails
          showDialog={showEditSFSContact}
          closeDialog={() => setShowEditSFSContact(false)}
          data={data}
        />
      )} */}

      {showDeactivateInspectionFirm && (
        <DeactivateInspectionFirm
          id={data?.id}
          name={data?.displayName}
          showDialog={showDeactivateInspectionFirm}
          closeDialog={() => setShowDeactivateClient(false)}
        />
      )}

      {showReActivateInspectionFirm && (
        <ReActivateInspectionFirm
          id={data?.id}
          showDialog={showReActivateInspectionFirm}
          closeDialog={() => setShowReActivateClient(false)}
        />
      )}
    </>
  );
}
